import { createSelector } from 'selectors'
import { textAnalytics } from './constant'

const { questionSettings } = textAnalytics

const getTextAnalyticsEditorQuestionsSelector = (): HTMLElement =>
	createSelector({ selector: questionSettings.editorQuestions })
const getTextAnalyticsEditorAvailableQuestionsSelector = (scope?: HTMLElement): HTMLElement =>
	createSelector({ scope, selector: questionSettings.editorAvailableQuestions })
const getTextAnalyticsEditorAssignedQuestionsSelector = (scope?: HTMLElement): HTMLElement =>
	createSelector({ scope, selector: questionSettings.editorAssignedQuestions })

export const getTextAnalyticsEditorSelectors = () => {
	const textAnalyticsEditorQuestions = getTextAnalyticsEditorQuestionsSelector()
	if (!textAnalyticsEditorQuestions) {
		return null
	}

	return {
		editorQuestions: textAnalyticsEditorQuestions,
		editorAvailableQuestions: getTextAnalyticsEditorAvailableQuestionsSelector(textAnalyticsEditorQuestions),
		editorAssignedQuestions: getTextAnalyticsEditorAssignedQuestionsSelector(textAnalyticsEditorQuestions),
	}
}
